<mc-scope class="size-wrap">
    <router-outlet></router-outlet>
</mc-scope>
